import gatewaySetting from './gateway-setting'
import gatewayInfo from './info-form'
import shaparakInfo from './shaparak-info'
import shaparakRequests from './shaparak-requests'

export {
    gatewayInfo,
    gatewaySetting,
    shaparakInfo,
    shaparakRequests
}